module.exports = __webpack_public_path__ + "static/img/prompt.54d0a1fb.png";